'use strict';

import numeral from 'numeral';

export default (number: number) => {
  if (number === 0) return '0';
  switch (Math.ceil(Math.log10(number)) % 3) {
    case 0: return numeral(number).format('0a');
    case 1: return numeral(number).format('0.[00]a');
    case 2: return numeral(number).format('0.[0]a');
    default: return '0';
  }
};
